import { render, staticRenderFns } from "./DeleteInvoice.vue?vue&type=template&id=0af4ad8c&scoped=true&"
import script from "./DeleteInvoice.vue?vue&type=script&lang=js&"
export * from "./DeleteInvoice.vue?vue&type=script&lang=js&"
import style0 from "./DeleteInvoice.vue?vue&type=style&index=0&id=0af4ad8c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0af4ad8c",
  null
  
)

export default component.exports